import { CSSProperties, FC, useCallback, useEffect, useState } from 'react';
import Select, { OptionProps, Options, components } from 'react-select';
import { selectStyles } from './styles';
import { Option, TNewValue } from 'shared/types';
import arrow from 'shared/assets/icons/arrow.svg';
import arrowTop from 'shared/assets/icons/arrowTop.svg';
import { ArrowContainer } from './styles';
import { Img } from 'shared/ui/imgStyledComponent';
import { useOutsideClickClose } from 'shared/lib/datepicker';
interface SelectValueProps {
	name?: string;
	options?: Options<Option>;
	defaultValue?: Option | null;
	changeValue?: boolean;
	onChange?: (newValue: TNewValue) => void;
	customMenu?: any;
	customValue?: any;
	customInput?: any;
	customControl?: any;
	prohibitOpening?: boolean;
}

const CustomOption: any = (props: OptionProps) => {
	const { innerRef, innerProps, data, selectProps } = props;
	const style = selectProps?.styles?.option?.({}, props) as
		| CSSProperties
		| undefined;
	const value = (data as Option)?.value;
	const label = (data as Option)?.label;

	return (
		<div
			ref={innerRef}
			{...innerProps}
			data-id={`value-marker-${value}`}
			style={style}
		>
			{label}
		</div>
	);
};

export const SelectValue: FC<SelectValueProps> = ({
	onChange,
	options,
	defaultValue,
	customMenu,
	customValue,
	customControl,
	customInput,
	prohibitOpening = false,
}) => {
	const [selectedOption, setSelectedOption] = useState(defaultValue);
	const [menuIsOpen, setMenuOpen] = useState(false);

	const scrollToValue = () => {
		const value = selectedOption?.value;

		if (value) {
			const valueMarker = document.querySelector(
				`[data-id="value-marker-${value}"]`,
			) as any;
			if (valueMarker) {
				const parentMarker = valueMarker.parentElement;
				if (parentMarker) {
					const valueMarkerPos =
						valueMarker.offsetTop;
					const parentMarkerPos =
						parentMarker.getBoundingClientRect().top;
					parentMarker.scrollTo({
						top: valueMarkerPos - parentMarkerPos,
					});
				}
			}
		}
	};



	const openMenu = async () => {
		if (prohibitOpening) {
			return;
		}
		await setMenuOpen(true);
		scrollToValue();
	};

	const closeMenu = () => {
		setMenuOpen(false);
	};

	useOutsideClickClose(closeMenu, 'time-select-input');

	const changeHandler = useCallback(
		(newValue: TNewValue) => {
			if (newValue) {
				setSelectedOption(newValue);
				if (onChange) {
					onChange(newValue);
				}
			}
		},
		[onChange],
	);

	useEffect(() => {
		if (defaultValue) {
			setSelectedOption(defaultValue);
		}
	}, [defaultValue]);

	return (
		<Select
			styles={selectStyles}
			defaultValue={defaultValue}
			options={options}
			value={selectedOption}
			onChange={changeHandler}
			components={{
				Menu: customMenu ? customMenu : components.Menu,
				ValueContainer: customValue
					? customValue
					: components.ValueContainer,
				Input: customInput ? customInput : components.Input,
				Control: customControl ? customControl : components.Control,
				DropdownIndicator: () => (
					<ArrowContainer>
						<Img
							src={menuIsOpen ? arrowTop : arrow}
							$size={'verySmall'}
						/>
					</ArrowContainer>
				),
				Option: CustomOption,
			}}
			onMenuOpen={openMenu}
			onMenuClose={closeMenu}
			menuIsOpen={menuIsOpen}
			isDisabled={prohibitOpening}
		/>
	);
};
